import { addPermissionsToRoute } from '@/myq-core/';

const routes = {
  name: 'People',
  icon: 'mdi-account-multiple-outline',
  path: '/reports/mcd/people/',
  children: [
    {
      path: '/reports/mcd/people/dashboard',
      name: 'People At A Glance',
      meta: { id: 'reports-peopleDashboard' },
      component: () => import('./dashboard/PeopleDashboard.vue'),
      tags: ['People Dashboard'],
    },
    {
      path: '/reports/mcd/people/employeeRoster',
      name: 'Employee Roster',
      meta: { id: 'reports-mcdEmployeeRoster' },
      component: () => import('./employeeRoster.vue'),
      ...addPermissionsToRoute(['mcdEmployeeRoster']),
    },
    {
      path: '/reports/mcd/people/birthdaysAnniversaries',
      name: 'Birthdays and Anniversaries',
      meta: { id: 'reports-mcdBirthdaysAnniversaries' },
      component: () => import('./birthdayAnniversary/birthdaysAnniversaries.vue'),
      ...addPermissionsToRoute(['reports_access']),
    },
    {
      path: '/reports/mcd/people/storePeoplePunches',
      name: 'Store Time Punches',
      component: () => import('./storeTimePunches.vue'),
      ...addPermissionsToRoute(['storePeoplePunches']),
      tags: ['Employee Time Punch Audit', 'Store Time Punches'],
    },
    {
      path: '/reports/mcd/people/punch-extract',
      name: 'Time Punch Export',
      component: () => import('./punch-extract.vue'),
      ...addPermissionsToRoute(['storePeoplePunches']),
      tags: ['Employee Time Punch Audit', 'Store Time Punches'],
    },
    {
      path: '/reports/mcd/people/laborExceptions',
      name: 'Labor Exceptions',
      meta: { id: 'reports-mcdLaborExceptions' },
      component: () => import('./laborExceptions/laborExceptions.vue'),
      ...addPermissionsToRoute(['mcdLaborExceptions']),
    },
    {
      path: '/reports/mcd/people/timeAttendance',
      name: 'Time and Attendance',
      meta: { id: 'reports-timeAttend' },
      component: () => import('./timeAttendance/timeAttendance.vue'),
      ...addPermissionsToRoute(['timeAttend']),
    },
    {
      path: '/reports/mcd/people/rosterStatistics',
      name: 'Roster Statistics',
      meta: { id: 'reports-rosterStatistics' },
      component: () => import('./rosterStatistics.vue'),
      ...addPermissionsToRoute(['rosterStatistics']),
    },
    {
      path: '/reports/mcd/people/turnoverReport',
      name: 'Turnover',
      meta: { id: 'reports-turnover' },
      component: () => import('./turnover/turnoverReport.vue'),
      ...addPermissionsToRoute(['turnover']),
      tags: [
        '12 Month Turnover',
        '3 Month Turnover',
        '3-Month Turnover',
        '12-Month Turnover',
      ],
    },
    {
      path: '/reports/mcd/people/empHoursThisWeek',
      name: 'Emp Hours This Week',
      meta: { id: 'reports-empHoursThisWeek' },
      component: () => import('./empHoursThisWeek.vue'),
      ...addPermissionsToRoute(['storePeoplePunches']),
    },
    {
      path: '/reports/mcd/people/shift',
      name: 'People Shift',
      meta: { id: 'reports-peopleShift' },
      component: () => import('./shift.vue'),
      ...addPermissionsToRoute(['shift']),
    },
  ],
};

export default routes;
